import { Stack } from "@mui/material";
import { SxProps } from "@mui/system";
import TimelinePlayer from "features/TimelinePlayer";
import TimelinePlayerContext from "features/TimelinePlayer/context/TimelinePlayerContext";
import TimelinePlayerProvider from "features/TimelinePlayer/TimelinePlayerProvider";
import { useContext } from "react";
import TimelineItem from "types/TimelineItem";
import ShareTimelineControls from "./ShareTimelineControls";

interface Props {
  timelineItems: TimelineItem[];
  sx?: SxProps;
}

export default function ShareTimelinePlayer({ timelineItems, sx }: Props) {
  return (
    <TimelinePlayerProvider>
      <ShareTimelinePlayerBody timelineItems={timelineItems} sx={sx} />
    </TimelinePlayerProvider>
  );
}

function ShareTimelinePlayerBody({ timelineItems, sx }: Props) {
  const { timelineItemId } = useContext(TimelinePlayerContext);

  return (
    <Stack
      sx={{
        display: "flex",
        flex: 1,
        height: "100%",
        minHeight: 0,
        width: "100%",
      }}
    >
      <TimelinePlayer
        key={timelineItemId}
        allowDownload={false}
        controls
        timelineItems={timelineItems}
        sx={sx}
      />
      <ShareTimelineControls timelineItems={timelineItems} />
    </Stack>
  );
}
